import React from "react";
import "./NewListingStyle.css";

const NewListingItem = ({ img, title, city, price, name }) => {
  return (
    <div className="mt-5">
      <div className="card-deck new_listing">
        <div className="card px-2">
          <div className="list_img">
            <img src={img} alt="" />
            <h6 className="name">{name}</h6>
          </div>
          <div className="card-body p-0">
            <p className="new-title pt-0 mb-0">{title}</p>
            <small className="new_list_city text-secondary">{city}</small>
            <h6 className="price mt-1">{price}</h6>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewListingItem;
